import pinkBouquet from '../images/bouquets/pinkBouquet.png';
import sunflowerBouquet from '../images/bouquets/sunflowerBouquet.png';
import purpleBouquet from '../images/bouquets/purpleBouquet.png';
import roseBouquet from '../images/bouquets/roseBouquet.png';

const bouquets = [
    {
        "name": "pinkBouquet",
        "src": pinkBouquet,
        "alt": "bouquet with 8 pink flowers and a white tapered vase",
    },
    {
        "name": "sunflowerBouquet",
        "src": sunflowerBouquet,
        "alt": "bouquet with 4 sunflowers and a mix of white fluffy cottontails and soft green eucalyptus leaves",
    },
    {
        "name": "purpleBouquet",
        "src": purpleBouquet,
        "alt": "bouquet with purple tulips, purple calla lily, and some sprigs of lavender",
    },
    {
        "name": "roseBouquet",
        "src": roseBouquet,
        "alt": "classic bouquet with 12 red roses and white baby's breathe",
    },
]

export default bouquets;